export const GET_OTP_REQUEST = "GET_OTP_REQUEST";
export const GET_OTP_FAILURE = "GET_OTP_FAILURE";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";

export const PUT_OTP_VALIDATE_REQUEST = "PUT_OTP_VALIDATE_REQUEST";
export const PUT_OTP_VALIDATE_FAILURE = "PUT_OTP_VALIDATE_FAILURE";
export const PUT_OTP_VALIDATE_SUCCESS = "PUT_OTP_VALIDATE_SUCCESS";
